define([
	"dojo/_base/declare",
	"csi/def",
	"csi/locale",
	"csi/prefs/_base",
	"csi/heading/Expression"
], function(declare,def,locale,prefs,Expression) {

	return declare(Expression, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: convert URL to localized view name
			var url = ctx.getNode().__Parent__;
			var	key = prefs.getContainerKey(url);
			var	keyObj = def.decomposeViewKey(key);
			return locale.typeView(keyObj.type, keyObj.id);
		}
	});
});